import { getJson, postJson } from './client'
import type { PropositionView, ValueProposition, WorkspaceView } from '../types/valueProps'

// Value propositions: the workspace behind a "could sell next" opening, and the propositions written in it.
const base = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/value-propositions`

export const valuePropsApi = {
  workspace: (spoke: string, companyId: string, line: string, approach?: string, targetPersonId?: string) =>
    getJson<WorkspaceView>(`${base(spoke)}/workspace`, { companyId, line, approach, targetPersonId }),
  list: (spoke: string, companyId?: string) => getJson<ValueProposition[]>(base(spoke), { companyId }),
  get: (spoke: string, id: string) => getJson<PropositionView>(`${base(spoke)}/${encodeURIComponent(id)}`),
  create: (spoke: string, body: { companyId: string; serviceLine: string; targetPersonId?: string; approach?: string }) =>
    postJson<PropositionView>(base(spoke), body),
  refine: (spoke: string, id: string, body: { ask?: string; edit?: string; approach?: string; targetPersonId?: string }) =>
    postJson<PropositionView>(`${base(spoke)}/${encodeURIComponent(id)}/refine`, body),
  accept: (spoke: string, id: string) => postJson<PropositionView>(`${base(spoke)}/${encodeURIComponent(id)}/accept`),
}
